module.exports = __webpack_public_path__ + "img/job_booking07.821e4b46.png";